import Vue from 'vue';
import Vuex from 'vuex';
import VueSession from 'vue-session';
import axios from 'axios';
import api from '../../utils/api';

const options = {
  persist: true
};

const baseUrl = process.env.VUE_APP_API_URL;

Vue.use(Vuex);
Vue.use(VueSession, options);

const state = {
  loginSuccess: null,
  error: ''
};

const getters = {
  getLoggedUser: state => state.loggedUser,
  isLoggedIn: state => state.isLoggedIn,
  getError: state => state.error
};

const actions = {
  login: ({ commit }, data) => {
    commit('reqInit', null, { root: true });

    api
      .post('/api/v1/admin/auth/login', data)
      .then(response => {
        if (response.status === 200) {
          const user = response.data.data;
          commit('loginSuccess', user, { root: true });
          commit('reqSuccess', null, { root: true });
          window.location.reload(true);
          return true;
        }
        commit('reqError', null, { root: true });

        return false;
      })
      .catch(error => {
        commit('reqError', null, { root: true });
        return error;
      });
    return true;
  },
  editPassword: ({ commit }, data) => {
    commit('reqInit', null, { root: true });
    const passwordData = { password: data.password };

    api
      .patch(`/api/v1/admin/user/${data.id}`, passwordData)
      .then(response => {
        if (response.status === 200) {
          commit('reqSuccess', null, { root: true });
          return true;
        }
        commit('reqError', null, { root: true });

        return false;
      })
      .catch(error => error);
  },
  forgetPassword: ({ commit }, data) => {
    commit('reqInit', null, { root: true });
    api
      .post('/api/v1/admin/auth/reset-password', data)
      .then(response => {
        if (response.status === 200) {
          // commit('reqInit', null, { root: true });
          commit('reqSuccess', null, { root: true });
          return true;
        }
        commit('reqError', null, { root: true });

        return false;
      })
      .catch(error => {
        commit('reqError', null, { root: true });
        return error;
      });
  },
  resetPassword: async({ commit }, data) => {
    commit('reqInit', null, { root: true });
    const config = {
      headers: {
        Authorization: data.bearerToken
      }
    };
    const newPassword = { password: data.password };

    const response = await axios.patch(`${baseUrl}/api/v1/admin/auth/reset-password`, newPassword, config);
    if (response.status === 200) {
      commit('reqSuccess', null, { root: true });
      return true;
    }
    commit('reqError', null, { root: true });
    return false;
  }
};

export default {
  namespaced: true,
  actions,
  state,
  getters
};
